<template>
    <div class="card h-100 border rounded-6" :class="this.miner.preferred ? 'shadow-lg border-info' : 'shadow-sm'">
        <div class="card-header rounded-top-6" :class="this.miner.preferred ? 'bg-info text-white' : 'bg-light'">
            <h5 class="card-title">
                <span v-if="miner.preferred">⭐</span>{{ miner.title }}
            </h5>
        </div>
        <div class="card-body">
            <p class="card-text">{{ miner.description }}</p>
            <div class="d-flex justify-content-between align-items-center fw-bold my-3">
                <span><a :href="miner.buyUrl" class="btn btn-primary rounded rounded-pill">Bestellen</a></span>
                <span style="font-size:1.2em">€ {{ miner.priceInEur.toFixed(2) }}</span>
            </div>
            <hr />
            <div class="d-flex justify-content-between align-items-center my-2">
                <span>Uitbetaling pool <i class="fa fa-info-circle text-muted" data-bs-toggle="tooltip" title="De uitbetaling door de pool is volatiel en is afhankelijk van een aantal factoren. Bekijk de FAQ voor meer informatie."></i></span>
                <crypto-euro-price :coin="poolPayoutCoin" :displayLeft="true" />
            </div>
            <div class="d-flex justify-content-between my-2">
                <span>Intrest <i class="fa fa-info-circle text-muted" data-bs-toggle="tooltip" title="Bij gebruik van de Crypto kluis ontvang je tot 4% intrest per jaar."></i></span>
                <crypto-euro-price :coin="intrestCoin" :displayLeft="true" />
            </div>
            <div class="d-flex justify-content-between my-2">
                <span>Kosten <i class="fa fa-info-circle text-muted" data-bs-toggle="tooltip" title="De energie- en onderhoudskosten worden berekend op basis van het verbruik van de fysieke miner en de TeraHash van de SkyMiner."></i></span>
                <crypto-euro-price :coin="energyCostCoin" :displayLeft="true" />
            </div>
            <!--<div class="d-flex justify-content-between my-2">
        <span>Korting <i class="fa fa-info-circle text-muted" data-bs-toggle="tooltip" title="xxx"></i></span>
        <crypto-euro-price :coin="discountCoin" :displayLeft="true" />
    </div>-->
            <hr />
            <div class="d-flex justify-content-between my-2 fw-bold">
                <span>Winst <i class="fa fa-info-circle text-muted" data-bs-toggle="tooltip" title="De winst is berekend op basis van bovenstaande instellingen."></i></span>
                <div class="fw-normal small">
                    <div>ROI <span class="fw-bold">{{ roi.toFixed(2) }} %</span></div>
                    <div>jaarlijks</div>
                </div>
                <div class="text-end">
                    <div>€ {{ profit.toFixed(2) }}</div>
                    <div class="small">{{ periodLabel }}</div>
                </div>
            </div>
        </div>
        <img class="card-img-bottom rounded-bottom-6" :src="'/images/' + miner.imageFileName" :alt="miner.title" />
    </div>
</template>

<script>
    import CryptoEuroPrice from './CryptoEuroPrice.vue';

    export default {
        name: "MinerCard",
        components: {
            CryptoEuroPrice
        },
        props: {
            miner: Object,
            periodInDays: Number,
            btcToEurRate: Number, 
            costPerPerWattPerDay: Number,
            bitcoinPayoutPerTeraHashPerDay: Number
        },
        computed: {
            energyCostCoin() {
                const wattPerDay = this.miner.hashRate * this.miner.wattPerTeraHash;
                const energyCost = wattPerDay * this.periodInDays * this.costPerPerWattPerDay;
                return {
                    currencyCode: "BTC",
                    amount: this.convertToBtc(energyCost),
                    amountInEuro: energyCost
                };
            },
            intrestCoin() {
                const poolPayoutInEur = this.poolPayoutCoin.amountInEuro;
                const energyCostInEur = this.energyCostCoin.amountInEuro;
                const intrest = (poolPayoutInEur - energyCostInEur) * 0.04; // up to 4% intrests if crypto vault is used
                return {
                    currencyCode: "BTC",
                    amount: this.convertToBtc(intrest),
                    amountInEuro: intrest
                };
            },
            discountCoin() {
                //future incentive: depending on reached badges apply 0.25% discount
                //const energyCost = this.energyCostCoin.amountInEuro;
                //const discount = -energyCost * 0.0025;
                const discount = 0;
                return {
                    currencyCode: "BTC",
                    amount: this.convertToBtc(discount),
                    amountInEuro: discount
                };
            },
            poolPayoutCoin() {
                const poolPayout = this.bitcoinPayoutPerTeraHashPerDay * this.periodInDays * this.miner.hashRate;
                return {
                    currencyCode: "BTC",
                    amount:poolPayout,
                    amountInEuro: this.convertToEuro(poolPayout)
                };
            },
            profit() {
                const poolPayoutInEur = this.poolPayoutCoin.amountInEuro; 
                const energyCostInEur = this.energyCostCoin.amountInEuro; 
                return poolPayoutInEur - energyCostInEur + this.intrestCoin.amountInEuro;
            },
            roi() {
                const poolPayoutInEur = this.bitcoinPayoutPerTeraHashPerDay * 365 * this.miner.hashRate * this.btcToEurRate;
                const energyCostInEur = this.miner.hashRate * this.miner.wattPerTeraHash * 365 * this.costPerPerWattPerDay;
                const intrest = (poolPayoutInEur - energyCostInEur) * 0.04; // up to 4% intrests if crypto vault is used
                const profit = poolPayoutInEur - energyCostInEur + intrest;
                return profit * 100 / this.miner.priceInEur;
            },
            periodLabel() {
                if (this.periodInDays == 1) return 'per dag';
                if (this.periodInDays < 32) return 'per maand';
                return 'per jaar';
            }
        },
        methods: {
            convertToEuro(priceInBtc) { 
                return priceInBtc * this.btcToEurRate;
            },
            convertToBtc(priceInEur) {
                return priceInEur / this.btcToEurRate;
            },
        }
    };
</script>
